const errorHandler = {
  getHTTPErrorHandler: () => null,
};

export default errorHandler;
